import { createSlice } from "@reduxjs/toolkit";
import {
  handleFullfillForFetchPoDetails,
  handlePendingForFetchPoDetails,
  handleRejectForFetchPoDetails,
  handleEditShortItems,
  handleEditOverItems,
  handleRemoveOSitems,
  handleAddOSitems,
  handleSearchOSitems,
  handleUpdateOSnavigationBlock,
  handleEnableSort,
  handleUpdateOSnotes,
  handleUpdateUserName,
  initialState,
  handleResetCreateOS,
  handleSelectAllPalletItems,
  handleGetStoreCreditDetailsForOSPending,
  handleGetStoreCreditDetailsForOSFulfilled,
  handleGetStoreCreditDetailsForOSRejected
} from "./CreateOsReducers";
import {
  fetchPoDetails,
  getStoreCreditDetailsForOS
} from "./CreateOsAsyncThunks";

const createOverShortSlice = createSlice({
  name: "createOs",
  initialState,
  reducers: {
    handleResetCreateOS,
    handleUpdateUserName,
    handleAddOSitems,
    handleSearchOSitems,
    handleUpdateOSnotes,
    handleRemoveOSitems,
    handleEditOverItems,
    handleEditShortItems,
    handleEnableSort,
    handleUpdateOSnavigationBlock,
    handleSelectAllPalletItems
  },
  extraReducers(builder) {
    builder
      .addCase(fetchPoDetails.pending, handlePendingForFetchPoDetails)
      .addCase(fetchPoDetails.fulfilled, handleFullfillForFetchPoDetails)
      .addCase(fetchPoDetails.rejected, handleRejectForFetchPoDetails)
      .addCase(
        getStoreCreditDetailsForOS.pending,
        handleGetStoreCreditDetailsForOSPending
      )
      .addCase(
        getStoreCreditDetailsForOS.fulfilled,
        handleGetStoreCreditDetailsForOSFulfilled
      )
      .addCase(
        getStoreCreditDetailsForOS.rejected,
        handleGetStoreCreditDetailsForOSRejected
      );
  }
});

export const {
  handleUpdateUserName: updateUserName,
  handleAddOSitems: addOverShortItem,
  handleUpdateOSnotes: updateOverShortNotes,
  handleSearchOSitems: searchOverShortItems,
  handleRemoveOSitems: removeOverShortItem,
  handleEditOverItems: editOver,
  handleEditShortItems: editShort,
  handleResetCreateOS: resetCreateOverShortSlice,
  handleUpdateOSnavigationBlock: updateNavigationBlocking,
  handleEnableSort: enableSort,
  handleSelectAllPalletItems: selectAllPalletItems
} = createOverShortSlice.actions;

export default createOverShortSlice.reducer;
